import { useThema } from "@/stores/Thema"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { FormEvent } from "react"
import { Button } from "@/components/Button"
import { Icon } from "@/components/Icon"
import { IconPlus } from "@tabler/icons-react"
import { Dialog, DialogTrigger, Heading, Text } from "react-aria-components"
import { Modal } from "@/components/Modal/Modal"
import { Form } from "@/components/Form/Form"
import { TextField } from "@/components/TextField"
import { chain } from "react-aria"

export const CreateThemeButton = () => {
    const thema = useThema()
    const queryClient = useQueryClient()
    const publishMutation = useMutation({
        mutationFn: thema.create,
        onSuccess: () => queryClient.invalidateQueries({queryKey: ["history"]})
    })

    const {isPending} = publishMutation

    const create = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const evt = e.nativeEvent as SubmitEvent
        const data = Object.fromEntries(new FormData(e.currentTarget)) as any

        evt.submitter?.setAttribute("disabled", "true")
        publishMutation.mutate(data.name)
    }

    return (
        <DialogTrigger>
            <Button isLoading={isPending} isDisabled={isPending}>
                <Text>THEME</Text>
                <Icon icon={IconPlus}/>
            </Button>
            <Modal isDismissable className="w-[650px] max-h-[400px]">
                <Dialog className="outline-none max-h-[inherit] p-8 dark">
                    {({close}) => <>
                        <Heading className="text-xl mb-2">Create Theme</Heading>
                        <Form onSubmit={chain(create, close)}>
                            <TextField label="Name" name="name" autoFocus />
                            <div className="flex gap-2 justify-end">
                                <Button onPress={close} treatment="link">CANCEL</Button>
                                <Button type="submit" className="flex">SAVE</Button>
                            </div>
                        </Form>
                    </>}
                </Dialog>
            </Modal>
        </DialogTrigger>
    )
}